import { parse, stringify } from 'query-string'

export function addPrototypeQueryParamsToUrlSearchString(
  currentSearchString: string,
  prototypeId: string
) {
  const queryParams = parse(currentSearchString) as Record<string, string>
  queryParams.prototype = prototypeId

  return stringify(queryParams)
}
